import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import brandLogo from "../../images/dd-logo.png";

// Reference navigation (Brand Document + dark-defensive-web.html):
// About Us | Platform | GRC Automation | Frameworks | Contact
// Anchor items scroll to sections on the home page.
const navItems = [
  { name: "About Us", to: "/about", type: "route" },
  { name: "Platform", section: "platform", type: "anchor" },
  { name: "GRC Automation", section: "grc-automation", type: "anchor", twoLine: ["GRC", "Automation"] },
  { name: "Frameworks", section: "frameworks", type: "anchor" },
  { name: "Contact", to: "/contact-us", type: "route" },
];

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleAnchor = (e, id) => {
    e.preventDefault();
    closeMenu();
    if (location.pathname === "/") {
      scrollToSection(id);
    } else {
      navigate("/", { state: { scrollTo: id } });
      // Home reads location.state on mount to complete the scroll.
    }
  };

  const isActiveRoute = (to) => location.pathname === to;

  return (
    <header className="dd-header">
      <div className="dd-header-inner">
        <Link className="dd-logo" to="/" onClick={closeMenu}>
          <img
            src={brandLogo}
            alt="Dark Defensive - Detect, Defend, Fortify. Return to the home page."
          />
        </Link>

        <button
          className="dd-nav-toggle"
          type="button"
          aria-expanded={menuOpen}
          aria-controls="ddMainNav"
          onClick={() => setMenuOpen((o) => !o)}
        >
          <span className="dd-visually-hidden">
            {menuOpen ? "Close main menu" : "Open main menu"}
          </span>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
            {menuOpen ? (
              <path d="M6 6l12 12M18 6L6 18" />
            ) : (
              <path d="M3 6h18M3 12h18M3 18h18" />
            )}
          </svg>
        </button>

        <nav
          className={`dd-nav${menuOpen ? " is-open" : ""}`}
          id="ddMainNav"
          aria-label="Main"
        >
          <ul>
            {navItems.map((item) =>
              item.type === "route" ? (
                <li key={item.name}>
                  <Link
                    to={item.to}
                    className={isActiveRoute(item.to) ? "is-active" : ""}
                    onClick={closeMenu}
                  >
                    {item.name}
                  </Link>
                </li>
              ) : (
                <li key={item.name}>
                  <a
                    href={`/#${item.section}`}
                    className={item.twoLine ? "dd-nav-two-line" : ""}
                    onClick={(e) => handleAnchor(e, item.section)}
                  >
                    {item.twoLine ? (
                      <>
                        {item.twoLine[0]}
                        <br />
                        {item.twoLine[1]}
                      </>
                    ) : (
                      item.name
                    )}
                  </a>
                </li>
              )
            )}
          </ul>
        </nav>

        <div className="dd-header-actions">
          <a className="dd-login-link" href="https://app.darkdefensive.com" onClick={closeMenu}>
            Log In
          </a>
          <Link className="dd-btn dd-btn-primary" to="/contact-us" onClick={closeMenu}>
            Request a Demo &gt;
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
